export default __webpack_public_path__ + "static/media/kkk.a8230ef5.png";